(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/page-category-games/assets/javascripts/page-category-games.js') >= 0) return;  svs.modules.push('/components/casino-react/page-category-games/assets/javascripts/page-category-games.js');

'use strict';

const _React = React,
  useEffect = _React.useEffect,
  useMemo = _React.useMemo;
const _ReactRouterDOM = ReactRouterDOM,
  useParams = _ReactRouterDOM.useParams;
const ErrorPage = svs.components.casino_react.page_error;
const GridDisplayModes = svs.components.casino_react.common.constants.GridDisplayModes;
const CasinoSection = svs.components.casino_react.casinoSection.CasinoSection;
const _svs$casino_react$sha = svs.casino_react.shared.data,
  cmsCategoryList = _svs$casino_react$sha.cmsCategoryList,
  cmsLiveCategoryList = _svs$casino_react$sha.cmsLiveCategoryList;
const setMetaTags = svs.components.lbUtils.setMetaTags.setMetaTags;
const SubHeader = svs.components.casino_react.sub_header.SubHeader;
const useSearchResults = svs.components.casino_react.casinoStore.hooks.useSearchResults;
const useSetSearchParams = svs.components.casino_react.hooks.useSetSearchParams;
const FilterAndSort = svs.components.casino_react.filterAndSort.FilterAndSort;
const actionButtons = () => React.createElement(FilterAndSort, null);
const PageCategoryGames = () => {
  const _useParams = useParams(),
    categoryType = _useParams.categoryType,
    categoryName = _useParams.categoryName;
  const _useSetSearchParams = useSetSearchParams(),
    setListIds = _useSetSearchParams.setListIds;
  const contentList = useMemo(() => categoryType === 'live' ? cmsLiveCategoryList : cmsCategoryList, [categoryType]);
  const categoryModel = useMemo(() => {
    var _contentList$find$mod, _contentList$find;
    return (_contentList$find$mod = (_contentList$find = contentList.find(game => game.model.systemName === categoryName)) === null || _contentList$find === void 0 ? void 0 : _contentList$find.model) !== null && _contentList$find$mod !== void 0 ? _contentList$find$mod : {};
  }, [categoryName, contentList]);
  useEffect(() => {
    if (categoryModel.contentList) {
      setListIds([categoryModel.contentList]);
    }
  }, [categoryModel.contentList]);
  const _useSearchResults = useSearchResults(),
    games = _useSearchResults.games,
    error = _useSearchResults.error,
    isLoading = _useSearchResults.isLoading,
    isFetching = _useSearchResults.isFetching,
    totalGamesCount = _useSearchResults.totalGamesCount,
    fetchMore = _useSearchResults.fetchMore;
  useEffect(() => {
    setMetaTags({
      docTitle: categoryModel.metaTitle,
      metaDesc: categoryModel.metaDescription
    });
  }, [categoryModel.metaTitle, categoryModel.metaDescription]);
  if (error) {
    return React.createElement(ErrorPage, null);
  }
  if (!(categoryModel !== null && categoryModel !== void 0 && categoryModel.contentList)) {
    return React.createElement("p", {
      className: "align-center margin-top-4 category-not-found"
    }, "Vi hittade inga resultat f\xF6r kategori:", ' ', React.createElement("span", {
      className: "f-italic bold"
    }, categoryName));
  }
  return React.createElement(React.Fragment, null, React.createElement(SubHeader, {
    title: categoryModel.name
  }), React.createElement(CasinoSection, {
    ActionButtons: actionButtons,
    displayMode: GridDisplayModes.GRID_UNRESTRICTED,
    fetchMore: fetchMore,
    isLoading: isLoading || isFetching,
    isSearchResult: (games === null || games === void 0 ? void 0 : games.length) === 0,
    items: games ? games : [],
    title: totalGamesCount ? "".concat(totalGamesCount, " spel") : '',
    totalGamesCount: totalGamesCount
  }));
};
setGlobal('svs.components.casino_react.pageCategoryGames.PageCategoryGames', PageCategoryGames);

 })(window);